module.exports = __webpack_public_path__ + "static/img/aboutbanner2.17fa8f0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/aboutbanner2.jpg
// module id = lLm7
// module chunks = 0